import React, { useCallback, useEffect, useState } from 'react';
import { format } from 'date-fns';
import { Modal, ModalBody, Spinner } from 'reactstrap';
import formatValue from '~/services/formatValue';

import api2 from '~/services/api2';

import formatPhone from '~/services/formatPhoneString';
import { useAuth } from '~/context/AuthContext';
import formatCompleteDate from '~/services/formatCompleteDate';
import { SiIfood } from 'react-icons/si';
import { Button, DefaultSelect, Hyperlink } from 'ui-kit-takeat';
import toast from 'react-hot-toast';
import { useOrder } from '~/context/orderContext';
import { CLUBE_METHOD } from '~/utils/consts';
import {
  HighlightIcon,
  IconTrash,
  IconTrashFilled,
  Button as ButtonUI,
} from 'takeat-design-system-ui-kit';
import { createPortal } from 'react-dom';
import IfoodOnDemand from '../Delivery/IfoodOnDemand';
import BuyerObservation from '../BuyerObservation';
import LogisticsFailWarning from '../LogisticsFailWarning';
import { ProgressMiddleBar } from '../ProgressComponent/ProgressMiddleBar';
import { ProgressCircle } from '../ProgressComponent/ProgressCircle';
import {
  Container,
  Table,
  Order,
  Body,
  Phone,
  Items,
  Item,
  ItemName,
  Complements,
  ComplementsThirdLevel,
  ComplementsTitle,
  Obs,
  DeliveryInfo,
  MotoboyDiv,
  DeliveryPrice,
  ValuesAdvance,
  ContainerValuesAdvance,
  ContainerValueAdvance,
  ContainerDeleteAdvance,
  OverlayAdvance,
  TextDeleteAdvance,
  TextOrderAdvance,
  ContainerFooterAdvance,
  ContainerInfoAdvance,
  ContainerAdvanceInfoPayment,
  HighlightIconFixed,
  ContainerAdvance,
} from './styles';

export default function EyeModalOrders({ item }) {
  const [orders, setOrders] = useState([]);
  const { user } = useAuth();
  const { updateIfoodOnDemandReady, setAcceptedBaskets, updateLogisticId } =
    useOrder();
  const [step, setStep] = useState(() => {
    if (!user.delivery_info.use_all_kanbans) {
      switch (item?.basket?.order_status) {
        case 'pending':
          return 0;
        case 'accepted':
          return 1;
        case 'ready':
          return 2;
        case 'finished':
          return 3;
        default:
          return 0;
      }
    }

    switch (item?.basket?.order_status) {
      case 'pending':
        return 0;
      case 'accepted':
      case 'ready':
        return 1;
      case 'ongoing':
        return 2;
      case 'delivered':
      case 'finished':
        return 3;
      default:
        return 0;
    }
  });

  const userName = item?.buyer
    ? formatPhone(
        item.buyer.phone
          ? item.buyer.phone
          : item.buyer.ifood_phone
          ? item.buyer.ifood_phone
          : item.buyer.neemo_phone || ''
      ) || item?.buyer.name
    : item?.waiter?.name;

  function changeValue(value) {
    const newValue = value.replace('.', ',');

    return newValue;
  }

  function capitalizeFirstLetter(word) {
    const match = word.match(/^(\d*)([A-Z]+)$/);

    if (!match) return word;

    const numbers = match[1];
    const letters = match[2];

    return numbers + letters.charAt(0) + letters.slice(1).toLowerCase();
  }

  const [modalDeleteAdvance, setModalDeleteAdvance] = useState(false);
  const [paymentsAdvance, setPaymentsAdvance] = useState(item?.payments);
  const [selectedPaymentId, setSelectedPaymentId] = useState(null);
  const total =
    paymentsAdvance?.reduce((sum, py) => sum + Number(py.payment_value), 0) ||
    0;
  const valuePercentage = (total / item.total_delivery_price) * 100;
  const [loadingDestroyPayment, setLoadingDestroyPayment] = useState(false);

  useEffect(() => {
    setPaymentsAdvance(item?.payments);
  }, [item]);

  const textMethodAdvance = Array.isArray(item?.payments)
    ? paymentsAdvance
        .filter((py) => Number(py.id) === Number(selectedPaymentId))
        .map((py, idx) => {
          const name = py.payment_method?.name ?? '—';
          const date = py.created_at
            ? new Date(py.created_at)
                .toLocaleString('pt-BR', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                })
                .replace(',', ' -')
            : '—';
          const value =
            py.payment_value != null
              ? Number(py.payment_value).toFixed(2).replace('.', ',')
              : '';
          return (
            <React.Fragment key={py.id}>
              {`${name} - ${date}   `}
              <strong>R$ {value}</strong>
            </React.Fragment>
          );
        })
    : '';

  const deletePayment = useCallback(
    async (id) => {
      setLoadingDestroyPayment(true);
      try {
        await api2.delete(`restaurants/payments/${id}`);
        setPaymentsAdvance((prev) =>
          prev.filter((p) => Number(p.id) !== Number(id))
        );

        if (Array.isArray(item?.payments)) {
          item.payments = item.payments.filter(
            (p) => Number(p.id) !== Number(id)
          );
        }
        setModalDeleteAdvance(false);
        toast.success('Pagamento removido com sucesso');
        setLoadingDestroyPayment(false);
      } catch (error) {
        console.log('error delete', error);
        setLoadingDestroyPayment(false);
      }
    },
    [item]
  );

  const getOrders = useCallback(async () => {
    try {
      const response = await api2.get(
        `/restaurants/basket-orders/${item.basket.id}`
      );

      setOrders(response.data);
    } catch (error) {
      console.log(error);
    }
  }, [item]);

  function searchTableName(table) {
    if (table.table_type === 'balcony') {
      return 'Balcão';
    }

    if (table.table_type === 'drive-thru') {
      return 'Drive-Thru';
    }

    if (table.table_type === 'pos') {
      return 'POS';
    }

    if (table?.table_type === 'self-service') {
      return 'Totem';
    }

    if (table.table_number === -10) {
      return 'Mesa Copa';
    }

    if (
      table.table_type === 'delivery' &&
      item?.scheduled_to &&
      !item?.with_withdrawal
    ) {
      return 'Delivery Agendado';
    }

    if (
      table.table_type === 'delivery' &&
      item?.scheduled_to &&
      item?.with_withdrawal
    ) {
      return 'Retirada Agendada';
    }

    if (table.table_type === 'delivery' && item?.with_withdrawal) {
      return 'Retirada';
    }

    if (table.table_type === 'delivery') {
      return 'Delivery';
    }

    if (table.table_type === 'command') {
      return `Comanda  ${table.table_number}`;
    }

    return `Mesa  ${table.table_number}`;
  }

  useEffect(() => {
    getOrders();
  }, [getOrders]);

  function isPaidMethod(paymentMethod) {
    const paidMethods = [301, CLUBE_METHOD, 572, 2548];
    return paidMethods.includes(paymentMethod?.id);
  }

  function getPaymentStatus(item) {
    if (item?.ifood_paid) {
      return 'Pagamento já efetuado.';
    }

    const paymentMethod = item?.intended_payment_method || item?.payment_method;

    if (isPaidMethod(paymentMethod)) {
      return 'Pagamento já efetuado';
    }
    if (item?.with_withdrawal) {
      return 'Pagamento na retirada.';
    }
    return 'Pagamento na entrega.';
  }

  const [modalOnDemand, setModalOnDemand] = useState(false);
  const toggleOnDemand = () => {
    setModalOnDemand(!modalOnDemand);
  };

  const [loadingCancelOnDemand, setLoadingCancelOnDemand] = useState(false);
  const [cancelOnDemandSelect, setCancelOnDemandSelect] = useState(null);

  const [cancelOnDemandOptions, setCancelOnDemandOptions] = useState([]);
  const getCancelOnDemandOptions = useCallback(async () => {
    try {
      const response = await api2.get(
        `/restaurants/ifood/cancellationReasons/${item.session_id}`,
        {
          params: {
            isOnDemand: true,
          },
        }
      );

      if (response.data?.code === '400 BAD_REQUEST') {
        toast.error('Erro ao consultar opções de cancelamento no iFood');
        return;
      }

      setCancelOnDemandOptions(response.data);
    } catch (error) {
      toast.error('Erro ao consultar opções de cancelamento no iFood');
      console.log(error);
    }
  }, [item]);

  const handleCancelOnDemand = useCallback(async () => {
    setLoadingCancelOnDemand(true);
    try {
      await api2.post(
        `/restaurants/ifood/cancel-on-demand/${item.session_id}`,
        {
          reason: cancelOnDemandSelect.label,
          cancellationCode: cancelOnDemandSelect.value,
        }
      );

      updateIfoodOnDemandReady({
        order_basket_id: item.basket.id,
        ifood_on_demand_id: null,
      });

      toggleCancelOnDemand();
      // setCancelOnDemandOptions(response.data);
    } catch (error) {
      toast.error('Erro ao solicitar cancelamento do Entrega Fácil');
      console.log(error);
    }
    setLoadingCancelOnDemand(false);
  }, [cancelOnDemandSelect, item]);

  const [modalCancelOnDemand, setModalCancelOnDemand] = useState(false);
  const toggleCancelOnDemand = () => {
    if (!modalCancelOnDemand) {
      getCancelOnDemandOptions();
      setCancelOnDemandSelect(null);
    }
    setModalCancelOnDemand(!modalCancelOnDemand);
  };

  const logisticChannel = user.use_agilizone
    ? 'AGILIZONE'
    : user.use_pickngo
    ? 'PICKNGO'
    : user.use_foody_delivery
    ? 'FOODY'
    : null;

  return (
    <Container>
      <Table>
        <strong>
          {item?.basket?.ifood_table
            ? item?.basket?.ifood_table
            : searchTableName(item.table)}
        </strong>
      </Table>

      {item?.table?.table_type === 'command' &&
        item?.basket?.command_table_number && (
          <p
            style={{ textAlign: 'center' }}
          >{`Mesa ${item?.basket?.command_table_number}`}</p>
        )}
      <Order>
        {item?.ifood_restaurant?.name && <p>{item?.ifood_restaurant?.name}</p>}
      </Order>
      {item?.table?.table_type === 'delivery' ? (
        <Order
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            borderBottom: '1px solid  #cdcdcd',
          }}
        >
          <span style={{ fontWeight: 'bold' }}>
            {' '}
            Pedido #{item?.basket.basket_id}{' '}
            {item?.attendance_password && ` / #${item?.attendance_password}`}
          </span>
          <span>
            {' '}
            {item?.buyer?.name} - {item?.buyer?.phone}{' '}
          </span>
          {item?.buyer_order_count != null && (
            <span>
              {item.buyer_order_count}º Pedido deste cliente
            </span>
          )}

          {item?.basket?.start_time && item?.scheduled_to && (
            <p>{`Pedido feito em ${formatCompleteDate(item?.basket?.start_time)}`}</p>
          )}
          {item?.scheduled_to && (
            <p>{`Agendado para ${formatCompleteDate(item?.scheduled_to)}`}</p>
          )}
        </Order>
      ) : (
        <Order
          style={{
            borderBottom: '1px solid  #cdcdcd',
          }}
        >
          <span>
            {' '}
            Pedido #{item?.basket.basket_id}{' '}
            {item?.attendance_password && ` / #${item?.attendance_password}`}
          </span>
        </Order>
      )}
      <Body>
        <Phone style={{ width: '100%' }}>
          {item?.table?.table_type === 'delivery' ? (
            <DeliveryInfo>
              {item?.basket?.order_status !== 'canceled' && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',

                    marginTop: '70px',
                    width: '104%',
                    marginBottom: 10,
                  }}
                >
                  <ProgressCircle
                    label="Feito"
                    hour={
                      item?.basket?.start_time
                        ? format(new Date(item.basket.start_time), 'HH:mm')
                        : '--'
                    }
                    step={step}
                    idx={0}
                  />
                  <ProgressMiddleBar step={step} idx={0} />
                  <ProgressCircle
                    label="Confirmado"
                    hour={
                      item?.accepted_at
                        ? format(new Date(item.accepted_at), 'HH:mm')
                        : '--'
                    }
                    step={step}
                    idx={1}
                  />
                  <ProgressMiddleBar step={step} idx={1} />
                  <ProgressCircle
                    label="Despachado"
                    hour={
                      item?.ready_at
                        ? format(new Date(item.ready_at), 'HH:mm')
                        : '--'
                    }
                    step={step}
                    idx={2}
                  />
                  <ProgressMiddleBar step={step} idx={2} />
                  <ProgressCircle
                    label={
                      item?.ifood_delivery_time && step < 3
                        ? 'Previsão'
                        : 'Entregue'
                    }
                    hour={
                      item?.ifood_delivery_time
                        ? format(new Date(item.ifood_delivery_time), 'HH:mm')
                        : '--'
                    }
                    step={step}
                    idx={3}
                  />
                </div>
              )}

              {item?.ifood_on_demand_id && (
                <>
                  <div style={{ marginTop: 10 }}>
                    <SiIfood
                      color="#FF2C3A"
                      size={17}
                      style={{ marginRight: 5 }}
                    />
                    Acompanhar entrega via Entrega Fácil:
                    <a
                      href={`https://meupedido.ifood.com.br/${item.ifood_on_demand_id}`}
                      target="_blank"
                      style={{ color: 'blue' }}
                      rel="noreferrer"
                    >
                      {' '}
                      clique aqui
                    </a>
                  </div>
                  <div style={{ marginBottom: 5 }}>
                    <Hyperlink
                      color="#FF2C3A"
                      fontSize={14}
                      textDecoration="underline"
                      onClick={toggleCancelOnDemand}
                    >
                      Cancelar entrega fácil
                    </Hyperlink>
                  </div>

                  <Modal
                    isOpen={modalCancelOnDemand}
                    toggle={toggleCancelOnDemand}
                  >
                    <ModalBody>
                      <p>
                        <strong>
                          Tem certeza que deseja cancelar a Entrega Fácil?
                        </strong>
                      </p>
                      <p>Selecione o motivo</p>
                      <DefaultSelect
                        name="Motivo do cancelamento"
                        options={cancelOnDemandOptions}
                        value={cancelOnDemandSelect}
                        onChange={(e) => setCancelOnDemandSelect(e)}
                      />

                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                          marginTop: 20,
                        }}
                      >
                        <Button title="Fechar" onClick={toggleCancelOnDemand} />

                        <Button
                          title="Confirmar"
                          buttonColor="#2EC9B7"
                          disabled={
                            !cancelOnDemandSelect || loadingCancelOnDemand
                          }
                          onClick={handleCancelOnDemand}
                        />
                      </div>
                    </ModalBody>
                  </Modal>
                </>
              )}
              {logisticChannel && !item.logistic_id && !item.with_withdrawal && (
                <LogisticsFailWarning
                  sessionId={item.session_id}
                  basketId={item.basket.id}
                  logisticChannel={logisticChannel}
                  onRetrySuccess={updateLogisticId}
                />
              )}
              {user.has_ifood &&
                // [
                //   2, 15516, 49803, 31884, 54753, 44424, 11556, 41322, 11556,
                //   61980, 64884, 62277, 66633, 73629, 69903, 69902, 67590, 69901,
                //   72408, 2316, 68679, 68712,
                // ].includes(user.id) &&
                user?.delivery_info?.use_ifood_on_demand &&
                !item?.basket?.ifood_id &&
                item.basket?.order_status === 'ready' &&
                item.buyer?.delivery_address?.latitude &&
                item.buyer?.delivery_address?.longitude &&
                !item.ifood_on_demand_id && (
                  <>
                    <Button
                      title={
                        <>
                          <SiIfood
                            color="#FF2C3A"
                            size={17}
                            style={{ marginRight: 5 }}
                          />{' '}
                          Entrega Fácil iFood
                        </>
                      }
                      inverted
                      style={{ paddingTop: 5, paddingBottom: 5 }}
                      onClick={toggleOnDemand}
                    />

                    <Modal isOpen={modalOnDemand} toggle={toggleOnDemand}>
                      <IfoodOnDemand
                        item={item}
                        user={user}
                        toggleModal={toggleOnDemand}
                      />
                    </Modal>
                  </>
                )}

              {item?.basket?.schedule && (
                <strong>
                  <span>{item?.basket?.schedule}</span>
                </strong>
              )}

              {item?.delivery_by &&
                (item?.delivery_by === 'MERCHANT' ? (
                  <p style={{ fontWeight: 'bold', fontSize: 16 }}>
                    <span style={{ fontWeight: 'normal' }}>
                      Entrega Própria{' '}
                      {capitalizeFirstLetter(item?.sales_channel)}
                    </span>
                  </p>
                ) : (
                  <p style={{ fontWeight: 'bold', fontSize: 16 }}>
                    <span style={{ fontWeight: 'normal' }}>
                      Entrega {capitalizeFirstLetter(item?.sales_channel)}
                    </span>
                  </p>
                ))}

              {item?.sales_channel === 'IFOOD' && (
                <span>
                  {item?.buyer?.ifood_phone} - Localizador Ifood:{' '}
                  {item?.buyer?.localizer}
                </span>
              )}

              {['99FOOD', 'KEETA', 'WABIZ'].includes(item?.sales_channel) && (
                <span> Telefone: {item.buyer?.ifood_phone} </span>
              )}

              {item?.with_withdrawal.toString() === 'false' && (
                <>
                  <p style={{ fontWeight: 'bold', fontSize: 16 }}>
                    Endereço de entrega
                  </p>
                  <span>
                    {item?.buyer?.delivery_address?.street || ''} -{' '}
                    {item?.buyer?.delivery_address?.number || ''}
                  </span>
                  <span>{item?.buyer?.delivery_address?.complement || ''}</span>
                  <span>
                    {item?.buyer?.delivery_address?.neighborhood || ''}
                  </span>
                  <span>
                    {item?.buyer?.delivery_address?.city || ''} -{' '}
                    {item?.buyer.delivery_address?.state || ''}
                  </span>
                  <span>{item?.buyer?.delivery_address?.zip_code || ''}</span>
                  <span>{item?.buyer?.delivery_address?.reference || ''}</span>
                </>
              )}

              {item?.with_withdrawal && (
                <span style={{ fontWeight: 'bold', marginTop: 10 }}>
                  Cliente irá retirar o produto.
                </span>
              )}
            </DeliveryInfo>
          ) : (
            <>
              {item?.buyer?.phone
                ? `${userName} - ${item?.buyer?.name || ''}`
                : `${userName} `}
            </>
          )}
        </Phone>
        {/* <Time>{formatTime(item?.basket.start_time)}</Time> */}

        {!item?.waiter && item?.waiter_owner && (
          <Phone style={{ width: '100%' }}>
            Garçom: {item.waiter_owner.name}
          </Phone>
        )}
      </Body>
      {item?.buyer?.id && <BuyerObservation buyer_id={item.buyer.id} readOnly={true} />}
      <Items>
        <p style={{ fontWeight: 'bold', fontSize: 16 }}>Pedido:</p>
        {orders.length > 0 ? (
          orders.map((order) => (
            <Item key={order.id}>
              <ItemName>
                {order.use_weight ? (
                  <span>
                    {changeValue(order.weight)}kg {order.product.name}
                  </span>
                ) : (
                  <span>
                    {order.amount}x {order.product.name}
                  </span>
                )}
              </ItemName>
              {order.complement_categories.map((category) => (
                <div key={category.id}>
                  <ComplementsTitle>
                    {category.complement_category.name}:
                  </ComplementsTitle>
                  {category.order_complements.map((complement) => (
                    <Complements key={complement.id}>
                      - {complement.amount} x {complement.complement.name}{' '}
                      {complement.details &&
                        complement.details.split('\n').map((line, index) => (
                          <ComplementsThirdLevel key={index}>
                            - {line}
                            <br />
                          </ComplementsThirdLevel>
                        ))}
                    </Complements>
                  ))}
                </div>
              ))}
              {order.details !== '' && <Obs>Obs: {order.details}</Obs>}
            </Item>
          ))
        ) : (
          <div style={{ marginTop: 20 }}>
            <Spinner />
          </div>
        )}
      </Items>

      {item?.table.table_type === 'delivery' && (
        <DeliveryPrice>
          <>
            <span>
              <span>{getPaymentStatus(item)}</span>
            </span>
          </>
          <span>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontWeight: 'bold', marginTop: 10, fontSize: 14 }}>
                Método de Pagamento
              </span>
              <span style={{ fontWeight: 'normal', fontSize: 14 }}>
                {item?.intended_payment_method?.name
                  ? item?.intended_payment_method?.name
                  : item?.payment_method?.name
                  ? item?.payment_method?.name
                  : 'Não informado'}
              </span>
            </div>
          </span>

          {item?.details && (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontWeight: 'bold', marginTop: 10, fontSize: 14 }}>
                Informações adicionais
              </span>
              <span style={{ fontWeight: 'normal', fontSize: 14 }}>
                {item?.details}
              </span>
            </div>
          )}
          <div style={{ marginTop: 10 }}>
            <span>Total do pedido:</span>
            <span>
              {formatValue(
                parseFloat(item?.basket?.total_price) +
                  parseFloat(item?.merchant_discount || 0) -
                  parseFloat(item?.additional_fees || 0)
              )}
            </span>
          </div>

          {item?.sales_channel !== '99FOOD' ? (
            <>
              {item.delivery_tax_price && (
                <div>
                  <span>Taxa de entrega:</span>
                  <span>{formatValue(item.delivery_tax_price)}</span>
                </div>
              )}

              {!item.basket?.ifood_id &&
                item.delivery_fee_discount &&
                item.delivery_fee_discount > 0 && (
                  <div>
                    <span>Cupom de entrega grátis aplicado</span>
                  </div>
                )}
            </>
          ) : (
            <>
              <div>
                <span>Taxa de entrega:</span>
                <span>
                  {formatValue(
                    parseFloat(item?.delivery_tax_price) +
                      parseFloat(item?.delivery_fee_discount || 0)
                  )}
                </span>
              </div>
              {item.delivery_fee_discount > 0 && (
                <div>
                  <span>Desconto na taxa de entrega:</span>
                  <span>- {formatValue(item?.delivery_fee_discount)}</span>
                </div>
              )}
            </>
          )}

          {item?.additional_fees && item?.additional_fees > 0 && (
            <div>
              <span>
                {item?.sales_channel === 'IFOOD'
                  ? 'Taxa de serviço iFood:'
                  : 'Outras taxas:'}
              </span>
              <span>{formatValue(item?.additional_fees)}</span>
            </div>
          )}
          {item?.coupon_discount &&
            item?.ifood_discount === null &&
            item?.merchant_discount === null && (
              <div>
                <span>Desconto de cupom:</span>
                <span>- {formatValue(item?.coupon_discount)}</span>
              </div>
            )}
          {item?.ifood_discount > 0 && (
            <div>
              <span>Cupom do iFood:</span>
              <span>- {formatValue(item?.ifood_discount)}</span>
            </div>
          )}
          {item?.merchant_discount > 0 && (
            <div>
              <span>Cupom do restaurante:</span>
              <span>- {formatValue(item?.merchant_discount)}</span>
            </div>
          )}
          {item?.rescue && (
            <div>
              <span>Resgate do clube:</span>
              <span>- {formatValue(item?.rescue?.cashback)}</span>
            </div>
          )}
          {item?.scheduled_to && (
            <>
              {paymentsAdvance?.length > 0 && (
                <div style={{ marginBottom: 0 }}>
                  <span>Pagamento parcial:</span>
                  <span>{`${Number(valuePercentage).toFixed(2)} %`}</span>
                </div>
              )}
              {paymentsAdvance
                ?.filter((py) => py.payment_value > 0)
                .map((py) => (
                  <>
                    <div style={{ marginBottom: 0 }}>
                      <ValuesAdvance>{py.payment_method.name}</ValuesAdvance>
                      <ContainerValueAdvance>
                        <span>{formatValue(Number(py.payment_value))}</span>
                        <IconTrash
                          style={{ cursor: 'pointer' }}
                          fill="#C8131B"
                          fontSize={24}
                          onClick={() => {
                            setSelectedPaymentId(py.id);
                            setModalDeleteAdvance(true);
                          }}
                        />
                      </ContainerValueAdvance>
                    </div>
                  </>
                ))}
            </>
          )}
          <div>
            <span>Total:</span>
            <span>
              {formatValue(
                Math.max(
                  Number(item?.total_delivery_price) -
                    (Number(item?.rescue?.cashback) || 0) -
                    Number(item?.subsidized_fees || 0) -
                    Number(item?.ifood_discount || 0),
                  0
                )
              )}
            </span>
          </div>

          {item?.user_change > 0 &&
            (item?.intended_payment_method?.name === 'Dinheiro' ||
              item?.intended_payment_method?.name === 'Dinheiro (iFood)' ||
              item?.payment_method?.name === 'Dinheiro') && (
              <>
                <div>
                  <span>Receber do cliente:</span>
                  <span>{formatValue(Number(item?.user_change))}</span>
                </div>
                <div>
                  <span>Troco:</span>
                  <span>
                    {formatValue(
                      Number(item?.user_change) -
                        (Number(item?.total_delivery_price) -
                          (Number(item?.rescue?.cashback) || 0) -
                          Number(item?.ifood_discount || 0))
                    )}
                  </span>
                </div>
              </>
            )}
        </DeliveryPrice>
      )}
      {item.motoboy && (
        <Items>
          <strong>Motoboy</strong>
          <MotoboyDiv>
            <span>{item.motoboy.name}</span>
            <span>
              {item.motoboy.phone
                ? `${item.motoboy.phone.substring(
                    0,
                    9
                  )}-${item.motoboy.phone.substring(9)}`
                : ''}
            </span>
          </MotoboyDiv>
        </Items>
      )}

      {modalDeleteAdvance &&
        createPortal(
          <OverlayAdvance>
            <ContainerAdvance>
              <ContainerDeleteAdvance>
                <HighlightIconFixed size={24} icon={<IconTrashFilled />} />
                <ContainerInfoAdvance>
                  <TextDeleteAdvance>
                    Tem certeza que deseja excluir este pagamento parcial?
                  </TextDeleteAdvance>
                  <ContainerAdvanceInfoPayment>
                    <TextOrderAdvance>
                      {' '}
                      Pedido #{item?.basket.basket_id}
                    </TextOrderAdvance>
                    <TextOrderAdvance $props>
                      {' '}
                      {item?.buyer?.name} - {item?.buyer?.phone}
                    </TextOrderAdvance>
                    {item?.basket?.start_time && (
                      <TextOrderAdvance $props>
                        {`Pedido feito em ${formatCompleteDate(item?.basket?.start_time)}`}
                      </TextOrderAdvance>
                    )}
                    <TextOrderAdvance
                      $props
                    >{`Agendado para ${formatCompleteDate(
                      item?.scheduled_to
                    )}`}</TextOrderAdvance>
                    <TextOrderAdvance $props $payment>
                      {textMethodAdvance}
                    </TextOrderAdvance>
                    <TextOrderAdvance $color>
                      Este pagamento será removido do caixa associado.
                      <br />
                      Ajuste os valores na conferência de caixa na Área do
                      Gestor.
                    </TextOrderAdvance>
                  </ContainerAdvanceInfoPayment>
                </ContainerInfoAdvance>
              </ContainerDeleteAdvance>
              <ContainerFooterAdvance>
                <ButtonUI
                  onClick={() => setModalDeleteAdvance(false)}
                  variant="outlined"
                  styled={{ width: 67 }}
                >
                  Cancelar
                </ButtonUI>
                <ButtonUI
                  isLoading={loadingDestroyPayment}
                  onClick={() => deletePayment(selectedPaymentId)}
                  styled={{ width: 47 }}
                >
                  Excluir
                </ButtonUI>
              </ContainerFooterAdvance>
            </ContainerAdvance>
          </OverlayAdvance>,
          document.body
        )}
    </Container>
  );
}